<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">添加</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-form-item label="图标" required >
                                    <el-upload
                                    class="upload-demo"
                                        :action="uploadUrl"
                                        list-type="picture-card"
                                        :data='uploadData'
                                        :show-file-list="false"
                                        :on-success="handleImgSuccess"
                                        style="width:100%;margin-top:40px">
                                        <img v-if="addForm.imgPath" :src="addForm.imgPath" fit='cover'  class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="排序" required prop="sort">
                                    <el-input v-model.number="addForm.sort" placeholder="请输入排序"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5, hex_md5_with_china} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props:['attributeList'],
        data() {
            return {
                loading: false,
                iconDialog: false,

                uploadUrl:this.$shopUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },

                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    imgPath:'',
                    sort:1,
                },
                rules:{
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                        //{ type: 'number', message: '排序必须为数字值'}
                    ],
                },

            }
        },

        methods: {
            init(){
                this.$refs.addForm.resetFields();
                this.addForm.imgPath ='';
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        if(!this.addForm.imgPath){
                            this.$message({type: 'warning', message: '请上传商品图标'});
                            return;
                        }
                        this.addSubmit();
                    }else {

                        return false;
                    }
                })

            },

            handleImgSuccess(res) {
                this.addForm.imgPath = this.$imgUrl+res.data.path;
            },
            iconPreview() {
                this.iconDialog = true;
            },

            addSubmit(){

              if(this.loading){
                  return;
              }else{
                  this.loading = true;
              }

              this.addForm.imgPath=this.addForm.imgPath.replace(this.$imgUrl,'')

              this.addForm.sign = "";
              this.addForm.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(this.addForm) + "&key="+this.$signKey)


                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AppBannerElderly/Add",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>

